import * as React from 'react';

import { getAppStore } from '~src/app/AppStore';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { WarningBanner } from '~src/app/spaces/Header/WarningBanner';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

import { areFlowParametersEnabled, containsAnyTypeParameter } from '../utils/FlowParametersUtils';
import { FlowDraftBanner } from './FlowDraftBanner';

const rootClass = 'FlowSpaceBanner';

const bannerWrapper = cssClass(rootClass, 'bannerWrapper', {
  $nest: {
    '& > div:not(:first-of-type)': {
      marginTop: 16,
    }
  }
});

export interface FlowSpaceBannerProps {
  readonly item: ISpaceItemDetailInfo<'flow'>;
}

export function FlowSpaceBanner(props: FlowSpaceBannerProps) {
  const state = getAppStore().getState();
  const shouldShowDraftBanner = FeatureFlags.flowDraftsEnabled && props.item && props.item.flowDraft;
  const shouldShowFlowParameterNotEnabledBanner = !areFlowParametersEnabled() && props.item.containsParameters;
  const shouldShowFlowParametersAnySettingNotEnabledBanner =
    areFlowParametersEnabled() &&
    !SessionSiteSelectors.flowParametersAnyTypeEnabled(state) &&
    containsAnyTypeParameter(props.item.relevantParameters || []);
  return (
    <div className={bannerWrapper}>
      { shouldShowDraftBanner ? <FlowDraftBanner flow={props.item} /> : null }
      { shouldShowFlowParameterNotEnabledBanner ? <WarningBanner message={Messages.flowParametersNotEnabledBannerDescription()} /> : null }
      { shouldShowFlowParametersAnySettingNotEnabledBanner ? <WarningBanner message={Messages.flowParametersAnySettingNotEnabledBannerDescription()} /> : null}
    </div>
  );
}
